import {getNamespaceByDomain, getNamespaceConfig, getNamespaceWithConfig} from "@/core/services/namespace-domain.js";

const getNamespaceById = (namespaceId) => getNamespaceConfig(namespaceId);

export default () => ({
    getNamespaceByDomain,
    getNamespaceById,
    getNamespaceWithConfig,
})
